import { forwardRef } from "react";
import CustomSearch from "../CustomSearch";
import userService from "../../services/user.service";

const UserSearch = forwardRef(function UserSearch(
  {
    onChange,
    notFoundData,
    optionalProps,
    alwaysShowNotFoundData = false,
    clearAfterChange = true,
  },
  ref
) {
  //const searchRef = useRef(null);
  const onSearch = async (q) => {
    const data = await userService.searchUser(q);
    // var data = [
    //   { id: 1, label: "Ram" },
    //   { id: 2, label: "Shayam" },
    // ];
    if (notFoundData) {
      if (alwaysShowNotFoundData || data.length === 0) data.push(notFoundData);
    }
    return data;
  };
  return (
    <CustomSearch
      onSearch={onSearch}
      onChange={(s) => {
        if (onChange instanceof Function) {
          if (s.length > 0) {
            const selected = s[0];
            onChange(selected);
          }
        }
        // console.log(s, searchRef);
      }}
      clearAfterChange={clearAfterChange}
      ref={ref}
      otherRequiredProps={{
        id: "patientSearch",
        placeholder: "Kapid Id, Name, Mobile Number",
        autoFocus: true,
        ...optionalProps,
      }}
    />
  );
});

export default UserSearch;
